
https://drive.google.com/drive/folders/156uPtJpa64d8GvBjonBN_KoiKN46rTgA?fbclid=IwAR2KXReNvakh4f1z5PkG1htXyVVcIc-oAR_KkDMkYU65w9ZhCegEcUYgrH4// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

})



export function SelectLocation_click(event) {
	$w('#megamenu').show(); 
}

export function SelectLocation_dblClick(event) {
	$w('#megamenu').show(); 
}

export function SelectLocation_mouseIn(event) {
	$w('#megamenu').show(); 
}

export function SelectLocation_mouseOut(event) {
	$w('#megamenu').hide(); 
}

export function SelectLocation_viewportLeave(event) {
	$w('#megamenu').show(); 
}

export function megamenu_mouseIn(event) {
	$w('#megamenu').show();  
}

export function megamenu_mouseOut(event) {
	$w('#megamenu').hide(); 
}